import React from 'react';
import TidyCalEmbed from '../TidyCalEmbed';
import SafeIcon from '../../common/SafeIcon';

export default function UnderinsuredResult({ answers }) {
  const hasEmployees = answers.q2 !== 'solo';
  const hasWorkersComp = (answers.q5 || []).includes('workers_comp');
  const needsWorkersComp = hasEmployees && !hasWorkersComp;

  return (
    <div className="w-full max-w-3xl mx-auto">
      <div className="bg-red-50 border-l-4 border-red-600 p-6 md:p-8 rounded-r-2xl mb-8 shadow-sm">
        <div className="flex items-start gap-4">
          <SafeIcon name="AlertTriangle" className="w-8 h-8 text-red-600 flex-shrink-0 mt-1" />
          <div>
            <h1 className="text-2xl md:text-3xl font-bold text-red-900 mb-2">
              Critical Alert: Your Business Has Dangerous Coverage Gaps
            </h1>
            <p className="text-red-800 text-lg">
              Based on your answers, your business is exposed to serious financial risk.
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-2xl shadow-xl p-6 md:p-10 mb-8">
        <h2 className="text-xl font-bold text-blue-900 mb-6">Key Issues Identified:</h2>
        <div className="space-y-4 mb-8">
          {needsWorkersComp && (
            <div className="flex gap-3 bg-red-50/50 p-4 rounded-xl border border-red-100">
              <span className="text-xl">⚠️</span>
              <div>
                <strong className="text-red-900 block mb-1">LEGALLY REQUIRED: Missing Workers' Comp</strong>
                <p className="text-gray-700 text-sm">You must have workers' compensation insurance in California. Operating without it can result in $10,000+ fines and personal liability for employee injuries.</p>
              </div>
            </div>
          )}
          {!(answers.q5 || []).includes('general_liability') && (
            <div className="flex gap-3 bg-gray-50 p-4 rounded-xl border border-gray-100">
              <span className="text-xl">🏢</span>
              <div>
                <strong className="text-blue-900 block mb-1">No General Liability Protection</strong>
                <p className="text-gray-700 text-sm">One customer injury or property damage claim could bankrupt your business.</p>
              </div>
            </div>
          )}
          {(answers.q7 || []).includes('store_customer_data') && !(answers.q5 || []).includes('cyber_liability') && (
            <div className="flex gap-3 bg-gray-50 p-4 rounded-xl border border-gray-100">
              <span className="text-xl">💻</span>
              <div>
                <strong className="text-blue-900 block mb-1">Data Breach Exposure</strong>
                <p className="text-gray-700 text-sm">You store data without cyber liability insurance. The average small business data breach costs over $200,000.</p>
              </div>
            </div>
          )}
        </div>

        <div className="bg-gray-50 p-6 rounded-xl mb-8">
          <h3 className="font-bold text-gray-900 mb-3">What This Means For You:</h3>
          <p className="text-gray-700 mb-4">Without proper coverage, YOU are personally liable for lawsuits or accidents. This could cost you your business AND your personal assets (home, savings, retirement).</p>
        </div>

        <h3 className="text-xl font-bold text-blue-900 mb-4">Next Step: Get Properly Protected NOW</h3>
        <p className="text-gray-600 mb-6">In a 20-minute consultation, we'll identify legally required coverages, recommend specific protections, and get you quotes from 15+ carriers within 24-48 hours.</p>
        
        <TidyCalEmbed />
      </div>
    </div>
  );
}